import { render, staticRenderFns } from "./View.vue?vue&type=template&id=1b43c80e&scoped=true"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"
import style0 from "./View.vue?vue&type=style&index=0&id=1b43c80e&prod&lang=scss&scoped=true"
import style1 from "./View.vue?vue&type=style&index=1&id=1b43c80e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b43c80e",
  null
  
)

export default component.exports